import { ValidatorFn, AbstractControl } from '@angular/forms';
import { NumberValidatorParams } from './number-validator-params';
import { NumberValidatorResult } from './number-validator-result';
import { ValidationErrorDetails } from '../validation-error-details';

const negativeRegex = new RegExp('^-\\d+(\\.\\d*)?');

export function numberValidator(params: NumberValidatorParams): ValidatorFn {
  return (control: AbstractControl): NumberValidatorResult | null => {
    const value: string = control.value;

    if (value === undefined || value === null || value === '') {
      return null;
    }

    const result = new NumberValidatorResult();

    let pattern = '^';

    if (!params.positive) {
      pattern += '-?';
    }

    pattern += '(\\d|[1-9]\\d*)';

    if (params.decimals > 0) {
      pattern += `(\\.\\d{0,${params.decimals}})?`;
    }

    pattern += '$';

    const regex = new RegExp(pattern);

    const testResult = regex.test(value);
    const negativeResult = negativeRegex.test(value);

    if (params.positive && !testResult && negativeResult) {
      result.isNegative = new ValidationErrorDetails(true, params);
      return result;
    }

    if (!regex.test(value)) {
      result.isNotNumber = new ValidationErrorDetails(true, params);
      return result;
    }

    const number = +value;

    if (number > params.max) {
      result.isTooBig = new ValidationErrorDetails(true, params);
      return result;
    }

    if (number < params.min) {
      result.isTooSmall = new ValidationErrorDetails(true, params);
      return result;
    }

    return null;
  };
}
